import { jsx as _jsx } from "react/jsx-runtime";
import FormHelperText from '@material-ui/core/FormHelperText';
import { helpId } from '@rjsf/utils';
/** The `FieldHelpTemplate` component renders any help desired for a field
 *
 * @param props - The `FieldHelpProps` to be rendered
 */
export default function FieldHelpTemplate(props) {
    const { idSchema, help } = props;
    if (!help) {
        return null;
    }
    const id = helpId(idSchema);
    return _jsx(FormHelperText, Object.assign({ id: id }, { children: help }));
}
//# sourceMappingURL=FieldHelpTemplate.js.map